export const FETCH_USER = 'fetch_user'
export const FETCH_ONE_USER = 'fetch_one_user'
export const CREATE_USER = 'fetch_one_user'